module.exports = __webpack_public_path__ + "static/000682-89ff9baa5ecd8c7fb2cf60359aacde0f.jpg";